import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import logo from '../../../assets/imgs/logo.png'
import { useRecoilState } from "recoil";
import getCookie, { districtAdminState, setDistrictCookie } from '../../Atom';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';

export default function Navbar() {
  let location = useLocation();
  const [activeNavbarIndex, setactiveNavbarIndex] = useState(1);
  let num=1;
  const [myUser, setmyUser] = useState();

  const logoutHandler=async()=>{
    setTimeout(()=>{
      setDistrictCookie({
        fName:null,
        lName:null,
        token:null,
        userId:null
      })
      let hostname= window.location.host;
      ////console.loghostname,window.location.protocol)
      window.location.assign(`${window.location.protocol}//${hostname}/school-district`)   
    })  
  }

  useEffect(()=>{
    const _cookie = getCookie('recoil-persist')
    if(!_cookie){
      logoutHandler()
    }else{
    const user = JSON.parse(_cookie)['district_admin_v1']
    setmyUser(user)
    }
  },[0])

  const makeActive = () => {
    const element = document.getElementById("dashboard");
    const device = document.getElementById("devices");
    const school = document.getElementById("school");
    const experiments = document.getElementById("experiments");
    const user = document.getElementById("users");
    const teacher = document.getElementById("teacher");
    const launchtrakfiles = document.getElementById("launchtrakfiles");
    if (location.pathname === '/') {
      element.classList.add("sidebar-active");
      device.classList.remove("sidebar-active");
      experiments.classList.remove("sidebar-active");
      user.classList.remove("sidebar-active");
      launchtrakfiles.classList.remove("sidebar-active");
      if(myUser?.schoolId){teacher.classList.remove("sidebar-active");}
      else{school.classList.remove("sidebar-active");
      }
    }
    else if (location.pathname === '/devices') {
      element.classList.remove("sidebar-active");
      device.classList.add("sidebar-active");
      // school.classList.remove("sidebar-active");
      experiments.classList.remove("sidebar-active");
      user.classList.remove("sidebar-active");
      launchtrakfiles.classList.remove("sidebar-active");
      // teacher.classList.remove("sidebar-active");
      if(myUser?.schoolId){teacher.classList.remove("sidebar-active");}
      else{school.classList.remove("sidebar-active");
      }

    }
    else if (location.pathname === '/experiments') {
     //console.log'get here1')
      element.classList.remove("sidebar-active");
      device.classList.remove("sidebar-active");
      // school.classList.remove("sidebar-active");
      experiments.classList.add("sidebar-active");
      user.classList.remove("sidebar-active");
      launchtrakfiles.classList.remove("sidebar-active");
      // teacher.classList.remove("sidebar-active");
      if(myUser?.schoolId){teacher.classList.remove("sidebar-active");}
      else{school.classList.remove("sidebar-active");
      }

    }
    else if (location.pathname.includes('/schools')){
      element.classList.remove("sidebar-active");
      device.classList.remove("sidebar-active");
     //console.log'get here')
      experiments.classList.remove("sidebar-active");
      user.classList.remove("sidebar-active");
      launchtrakfiles.classList.remove("sidebar-active");
      if(myUser?.schoolId){
        teacher.classList.add("sidebar-active");
        // school.classList.remove("sidebar-active");
      }else{
        // teacher.classList.remove("sidebar-active");
        school.classList.add("sidebar-active");
      }
    }
    else if (location.pathname === '/users'){
      element.classList.remove("sidebar-active");
      device.classList.remove("sidebar-active");
      // school.classList.remove("sidebar-active");
      experiments.classList.remove("sidebar-active");
      user.classList.add("sidebar-active");
      launchtrakfiles.classList.remove("sidebar-active");
      // teacher.classList.remove("sidebar-active");
      if(myUser?.schoolId){teacher.classList.remove("sidebar-active");}
      else{school.classList.remove("sidebar-active");
      }
    }
    else if (location.pathname === '/launchtrakfiles'){
      element.classList.remove("sidebar-active");
      device.classList.remove("sidebar-active");
      // school.classList.remove("sidebar-active");
      experiments.classList.remove("sidebar-active");
      user.classList.remove("sidebar-active");
      launchtrakfiles.classList.add("sidebar-active");
      // teacher.classList.remove("sidebar-active");
      if(myUser?.schoolId){teacher.classList.remove("sidebar-active");}
      else{school.classList.remove("sidebar-active");
      }
    }
  }

  useEffect(() => {
    // switch (location.pathname) {
    //   case "/":{num=1;
    //     setactiveNavbarIndex(1);
    //     break;}

    //   case "/devices":{num=2;
    //     setactiveNavbarIndex(2);
    //   }
    //     break;

    //   case "/schools":{num=3;
    //     setactiveNavbarIndex(3);
    //     break;}
      
    //   case "/experiments":{num=4;
    //     setactiveNavbarIndex(4);
    //     break;}

    //   case "/users":{num=5;
    //     setactiveNavbarIndex(5);
    //       break;}

    //   default:{num=3;
    //     setactiveNavbarIndex(3);}
        
    // }
    makeActive()
  }, [location]);


  return (
    <div className="side-bar-district">
      <div className="sidebar-logo">
        <img src={logo} alt="logo"/>
      </div>
      <div className="d-flex flex-column">

        <Link to="/">
          <div
            className="list-group-item"   
            id="dashboard"
          >
            <i className="fas fa-laptop"></i>
            <span> DashBoard</span>
          </div>
        </Link>
        {myUser?.type=='individual'?
        <Link to={`/schools/${myUser?.schoolId}`}>
          <div
            className="list-group-item"
            id="teacher"
          >
            <i className="fa fa-graduation-cap"></i>
            <span>Teachers</span>
          </div>
        </Link>
          :
        <Link to="/schools">
          <div
            className="list-group-item" 
            id="school"
          >
            <i className="fa fa-graduation-cap"></i>
            <span>Schools</span>
          </div>
        </Link>
        }

        <Link to="/users">
          <div
            className="list-group-item"
            id="users"
          >
            <SensorOccupiedIcon/>
            <span>Users</span>
          </div>
        </Link>

        <Link to="/devices">
          <div
            className="list-group-item"
            id="devices"
          >
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
            </svg>
            <span>Devices</span>
          </div>
        </Link>
        <Link to="/experiments">
          <div
            className="list-group-item"
            id="experiments"
          >
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
            </svg>
            <span>Beta Experiments</span>
          </div>
        </Link>
        <Link to="/launchtrakfiles">
          <div
            className="list-group-item"
            id="launchtrakfiles"
          >
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
              <path d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z" fill="currentColor" stroke="currentColor" strokeWidth="0.6"/>
            </svg>
            <span>LaunchTrak Files</span>
          </div>
        </Link>
        </div>
    </div>
  );
}
